const colors = {
  lightBlue: '#ccdce1',
  red: '#830505',
  lightGray: '#e8e8e8',
  darkGray: '#2d2d2d',
  headingTextShadowGrey: '#001635',
  copyColor: '#292929',
  copyIcons: '#525252'
};

export default colors;
